module.exports = __webpack_public_path__ + "static/media/onza_thumb_even.79ce8492.jpg";